// @Vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');
// @Commons
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @ Utils
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ helpers
const { countActiveFilters } = require('utilities/filtersHelper');

class ReferralsInvitationsContentFilters extends React.Component {

    buildStateFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterState = immFilter.get('state');
        let stateLabel = formatText(`filterReferralsInvitationsState-${immFilterState.get('selected').toLowerCase()}`);
        return (
            <LabelFilterRange
                closeCallback={() => resetFilter('state')}
                key="filter-state"
                from={stateLabel}
            />
        );
    }

    buildDateFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const language = getLanguage();
        const labelFromDate = immFilterDate.get('from').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immFilterDate.get('to').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => resetFilter('date')}
            />
        );
    }

    buildGiftFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterGift = immFilter.get('gift');
        const giftLabel = immFilterGift.get('selected');
        return (
            <LabelFilterRange
                closeCallback={() => resetFilter('gift')}
                key="filter-gift"
                from={giftLabel}
            />
        );
    }

    createButtonClearAllFilters() {
        const { immFilter, clearFilters } = this.props;
        let response;

        if (countActiveFilters(immFilter) > 1) {
            response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={clearFilters} />;
        }

        return response;
    }

    render() {
        const { immFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const immFilterState = immFilter.get('state');
        const immFilterGift = immFilter.get('gift');
        const clearAllFiltersButton = this.createButtonClearAllFilters();

        let filterDateLabel;
        let stateFilterActiveContent;
        let filterGiftLabel;

        if (immFilterDate.get('isActive')) {
            filterDateLabel = this.buildDateFilterLabel();
        }

        if (immFilterState.get('isActive')) {
            stateFilterActiveContent = this.buildStateFilterLabel();
        }

        if (immFilterGift.get('isActive')) {
            filterGiftLabel = this.buildGiftFilterLabel();
        }

        return (
            <div>
                {stateFilterActiveContent}
                {filterDateLabel}
                {filterGiftLabel}
                {clearAllFiltersButton}
            </div>
        );
    }
}

ReferralsInvitationsContentFilters.propTypes = {
    immFilter: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired
}

module.exports = ReferralsInvitationsContentFilters;
